const adminBackofficeDictEN = {
  adverts: "Adverts",
  users: "Users",
  orders: "Orders",
  paidSubscriptions: "Paid Subscriptions",
  paymentMethod: "Payment method",
  initialSub: "Initial Registration",
  annualRenewal: "Annual Renewal",
  test: "test",
  adminDashboard: "Admin Dashboard",
  withdrawRequests: "Withdraw requests",
  excWithdrawRequests: "Extracoin Withdrawals",
  markExcWithdrawCompleted: "Mark as completed",
  processThisExcWithdrawRequest: "Mark this request as completed?",
  excWithdrawProcessedSuccessfully: "Extracoin withdrawal request processed successfully!",
  searchByUsernameEmailAddress: "Search by username, email or address",
  requestDate: "Request date",
  processDate: "Process date",
  processing: "Processing",
  amountToDeposit: "Amount to deposit",
  amountRequested: "Amount requested",
  processRequest: "Process request",
  process: "Process",
  processedBy: "Processed by",
  withdrawProcessedSuccessfully: "Withdraw request processed successfully!",
  blockOrUnblockUser: "Block/Unblock user",
  block: "Block",
  unblock: "Unblock",
  user: "User",
  processThisRequest: "Process this request?",
  userBlockedSuccessfully: "User blocked successfully.",
  userUnblockedSuccessfully: "User unblocked successfully!",
  areYouSureBlockUser: "Are you sure you want to block this user?",
  areYouSureUnblockUser: "Are you sure you want to unblock this user?",
  blocked: "Blocked",
  yes: "Yes",
  no: "No",
  category: "Category",
  searchCategory: "Search Category",
  categoriesRegistered: "Registered Categories",
  image: "Image",
  descriptionPT: "Portuguese description",
  descriptionIT: "Italian description",
  descriptionES: "Spanish description",
  descriptionEN: "English description",
  registerNewCategory: "Register new Category",
  addNewCategory: "Add New Category",
  newCategory: "New",
  categoryInfo: "Category info",
  categoryFields: "Fill in the fields with the category information.",
  categoryImage: "Category Image",
  dragImg: "Drag your image here",
  registerCategory: "Register",
  descriptionBrand: "Brand description",
  brandsRegistered: "Trademarks",
  brands: "Brands",
  addNewBrand: "Add new brand",
  brandInfo: "Brand info",
  brandFields: "Fill in the field with brand information.",
  registerBrand: "Register",
  newBrand: "New",
  typesCategoriesRegistered: "Types Categories Registered",
  descriptionType: "Description",
  descriptionTypeEN: "English description",
  descriptionTypeES: "Spanish description",
  descriptionTypeIT: "Italian Description",
  descriptionTypePT: "Portuguese description",
  types: "Types",
  addNewType: "Add new types",
  typeInfo: "Type information",
  typeFields: "Fill in the fields with the type information.",
  newType: "New",
  registerType: "Register",
  subcategory: "Subcategories",
  newsubcategory: "New",
  subcategoriesRegistered: "Registered Subcategories",
  descriptionSubcategoryEN: "English Description",
  descriptionSubcategoryIT: "Italian Description",
  descriptionSubcategoryPT: "Portuguese Description",
  descriptionSubcategoryES: "Spanish Description",
  service: "service",
  addNewSubcategory: "Add New Subcategory",
  subcategoryInfo: "Subcategory information",
  subcategoryFields: "Fill in the fields with the subcategory information.",
  subcategoryImage: "Subcategory image",
  registerSubcategory: "Register",
  chooseSubcategory: "Choose at least one subcategory",
  address: "Address",
  userType: "User type",
  chooseUser: "choose a user",
  chooseAddress: "choose an address",
  UserAddressOnSendCloud: "Was the user's address registered in sendcloud?",
  searchUser: "Search user.",
  userInfo: "User information",
  adminBackofficeName: "Name",
  hasNoAttribute: "Has no",
  adminBackofficeUserType: "User type",
  adminBackofficeCountry: "Country",
  adminBackofficeAddress: "Address",
  adminBackofficeCity: "City",
  adminBackofficeState: "State",
  adminBackofficeDistrict: "District",
  adminBackofficePostalCode: "Postal code",
  adminBackofficeNumber: "Number",
  adminBackofficeComplement: "Complement",
  adminBackofficeDateCreation: "Date of creation",
  adminBackofficePhoneNumber: "Phone",
  adminBackofficeOriginRegister: "Origin of registration",
  searchByEmail: "search by email",
  searchByFirstname: "search by name",
  searchByPhonenumber: "Search by phone number",
  searchByReferralName: "Search by referral",
  searchByBrand: "search by brand",
  usersOfSystem: "System users",
  productsNotPublished: "Products not published",
  archivedProducts: "Archived products",
  productsPublished: "Published products",
  salesRevenue: "Sales revenue",
  feeRevenue: "Fee revenue",
  registeredStores: "Registered stores",
  completedOrders: "Completed orders",
  revenueFromUserRegistration: "Revenue from user registration",
  productsOfSystem: "System products",
  filters: "Filters",
  search: "Search",
  searchByNameSurnameUserAccountBank: "Search by name, surname, user, bank account",
  ordersPlacedWithBangood: "Orders placed with Bangood",
  actions: "Actions",
  processOrderSuccessfully: "Order processed successfully!",
  metaAdsConfig: "Setting up Meta Ads",
  integrationConfig: "Integration settings",
  editIntegrationConfig: "Edit configuration",
  accessToken: "Access token",
  pixelNumberId: "Pixel ID number",
  savePixelConfig: "Save configuration",
  integrations: "Integrations",
  pixelConfigSaved: "Configuration saved!",
  pixelConfigSavedDetail: "Your Meta ad settings have been successfully saved.",
  pixelConfigError: "Unexpected error",
  pixelConfigErrorDetail: "An error occurred while trying to save your settings.",
  fillInAllFields: "Fill in all the fields!",
  googleTagManagerConfiguration: "Configure Google Tag Manager",
  gtmCodeSaved: "GTM code saved",
  gtmCode: "GTM Code",
  gtmEdit: "Edit GTM Code",
  gtmRegister: "Register GTM Code",
  confirmed: "Payment Confirmed",
  paymentConfirmed: "You have successfully confirmed receipt of payment by bank transfer.",
  pendingOrders: "Pending orders",
  transferConfirm: "Confirm Transfer",
  buyer: "Buyer",
  totalAmount: "Total Paid",
  date: "Date",
  noPendingOrders: "No pending bank transfer orders.",
  youHavePendingOrders: "You have pending sales",
  youHavePendingUsers: "You have pending users",
  seeYourPendingOrders: "Check your pending bank transfer sales.",
  seeYourPendingUsersBankTransfer: "Check your pending bank transfer users.",
  pendings: "Pending sales",
  usersPendings: "Pending users",
  bankTransfers: "Bank transfers",
  receipt: "Receipt",
  searchForPlan: "Search by plan",
  authorize: "Authorize",
  confirmTransfer: "Confirm transfer?",
  pendingIssues: "Pending issues",
  quantityOfWithdrawsCompleted: "Quantity of completed withdrawals",
  totalAmountWithdrawsCompleted: "Total amount of completed withdrawals",
  totalOfUsersPublishedAds: "Total of users with published ads",
  totalofCommissionsPaid: "Total of commissions paid",
  bestOffers: "BEST OFFERS",
  youHaveUnprocessedOrders: "You have unprocessed Bangood orders",
  pendingBangoodOrders: "View your unprocessed Bangood orders.",
  bannersOfShop: "Shop banners",
  dragJustOneImage: "Drag just one image",
  language: "Language",
  english: "English",
  portuguese: "Português",
  italian: "Italiano",
  spanish: "Español",
  dontHaveImage: "Don't have an image?",
  principalBanner: "Main banner",
  file: "File",
  showBanner: "Show banner",
  noImageSelected: "No image selected",
  keepImageInRequiredAspectRatio: "Keep the image in the required aspect ratio",
  doYouWantToRepeatThisImage: "Do you want to repeat this image for another banner?",
  documents: "Documents",
  document: "Document",
  seeDoc: "See document",
  downloadDoc: "Download document",
  urlToRedirect: "Url to redirect user when clicking on the banner",
  addNewBanner: "Add new banner",
  removeBanner: "Remove banner",
  settingsSaved: "Settings saved",
  generalSettings: "General settings",
  sliderChangeTime: "Slider change time",
  seconds: "Seconds",
  imageDesktopEnglish: "Desktop image in English",
  imageDesktopItalian: "Desktop image in Italian",
  imageDesktopPortuguese: "Desktop image in Portuguese",
  imageDesktopSpanish: "Desktop image in Spanish",
  imageMobileEnglish: "Mobile image in English",
  imageMobileItalian: "Mobile image in Italian",
  imageMobilePortuguese: "Mobile image in Portuguese",
  imageMobileSpanish: "Mobile image in Spanish",
  youHavePendingWithdraws: "You have pending withdraws",
  seeYourPendingWithdraws: "See your pending withdraws.",
  youHavePendingPhysicalStores: "You have pending physical store verifications",
  seeYourPendingPhysicalStores: "Review the stores awaiting approval.",
  withdrawPendings: "Pending withdraws",
  subnets: "Subnets",
  ownerName: "Owner name",
  pleaseEnterName: "Please enter a name",
  pleaseEnterDescription: "Please enter a description",
  pleaseSelectManager: "Please select a manager",
  whitelabelSubnetCreatedSuccessfully: "Whitelabel subnet created successfully",
  errorCreatingWhitelabelSubnet: "Error creating Whitelabel subnet",
  personalizeSubnetTheme: "Personalize subnet theme",
  personalizeTeam: "Personalize theme",
  reports: "Accounting reports",
  paidOrdersReport: "Paid Orders Report",
  completedWithdrawalsReport: "Completed Withdrawals Report",
  paidSubscriptionsReport: "Paid Subscriptions Report",
  downloadPdf: "Download PDF",
  noData: "No data available",
  pdfDownloadedSuccessfully: "PDF downloaded successfully",
  errorDownloadingPdf: "Error downloading PDF",
  errorFetchingData: "Error fetching data",
  success: "Success",
  taxId: "Tax ID",
  planType: "Plan Type",
  startDate: "Start Date",
  endDate: "End Date",
  exportData: "Export data",
  paidOrdersHeaderNumber: "No.",
  paidOrdersHeaderBuyer: "Buyer",
  paidOrdersHeaderSeller: "Seller",
  paidOrdersHeaderDate: "Date",
  paidOrdersHeaderOrderAmount: "Order Amt.",
  paidOrdersHeaderPaidAmount: "Paid Amt.",
  paidOrdersHeaderCommission: "Commission",
  paidOrdersHeaderPayPal: "PayPal",
  paidOrdersHeaderWallet: "Wallet",
  paidOrdersHeaderExtraCredit: "ExtraCredit",
  paidOrdersHeaderBankTransfer: "Bank Transfer",
  paidOrdersHeaderStatus: "Status",
  paidOrdersHeaderInvoiceBuyer: "Buyer Invoice",
  paidOrdersHeaderInvoiceSeller: "Seller Invoice",
  paidOrdersHeaderPlatformFeeBuyer: "Buyer Platform Fee (5%)",
  paidOrdersHeaderPlatformFeeSeller: "Seller Platform Fee (5%)",
  paidOrdersHeaderPaidToSeller: "Paid to Seller",
  paidOrdersStatusOnHold: "Pending",
  completedWithdrawalsHeaderId: "ID",
  completedWithdrawalsHeaderDestination: "Destination",
  completedWithdrawalsHeaderProcessedBy: "Processed by",
  completedWithdrawalsHeaderRequestDate: "Request date",
  completedWithdrawalsHeaderProcessDate: "Process date",
  completedWithdrawalsHeaderAmountRequested: "Requested amount",
  completedWithdrawalsHeaderAmountToDeposit: "Amount to deposit",
  completedWithdrawalsHeaderFee: "Fee",
  completedWithdrawalsColDestinationType: "Dest. Type",
  completedWithdrawalsColPayment: "Payment",
  completedWithdrawalsColRequestedValue: "Req. Amount",
  completedWithdrawalsColNetValue: "Net Amount",
  searchBySurname: "Search by surname",
  searchByDocument: "Search by document",
  searchByAddress: "Search by address",
  searchByPaymentMethod: "Search by payment method",
  orderNumber: "Order number",
  logoutAccount: "Logout account",
  logoOrFavicon: "You can upload only the logo, only the favicon, or both",
  footerFieldsInfo: "Os campos abaixo vão aparecer no footer do dashboard do whitelabel.",
  approveStore: "Approve store",
  rejectStore: "Reject store",
  confirmApproveStore: "Are you sure you want to approve this store?",
  enterRejectionReason: "Enter the reason for rejection",
  storeApprovedSuccessfully: "Store approved successfully!",
  storeRejectedSuccessfully: "Store rejected successfully!",
  physicalStores: "Physical Stores",
  physicalStoresRegistered: "Approved Physical Stores",
  physicalStoresApproved: "Approved Stores",
  physicalStoresPending: "Pending Verifications",
  searchByStoreName: "Search by store name",
  physicalStoreName: "Store name",
  storeOwner: "Owner",
  viewDetails: "View details",
  storeDetails: "Store details",
  conventionPdf: "Convention PDF",
  legalRepresentative: "Legal representative",
  piva: "VAT number (PIVA)",
  signatureIp: "Signature IP",
  signedAt: "Signed at",
  openPhoto: "Open photo",
  openConvention: "Open convention PDF",
  establishmentPhoto: "Establishment photo",
  verificationStatus: "Status",
  submittedAt: "Submitted at",
  statusPending: "Pending",
  statusApproved: "Approved",
  statusRejected: "Rejected",
  storeCompanyName: "Company name",
  commercialName: "Commercial name",
  merchantCategory: "Establishment category",
  storePhone: "Store phone",
  invoiceStatus: "Invoicing",
  invoiceStatusSent: "Invoice issued",
  invoiceStatusError: "Error issuing invoice",
  invoiceStatusPending: "Invoice pending",
  invoiceStatusNotApplicable: "Not applicable",
  automaticInvoicing: "Automatic Invoicing",
  automaticInvoicingDescription: "Enable or disable automatic electronic invoice issuance for paid subscriptions and orders.",
  invoicingEnabledSuccessfully: "Automatic invoicing enabled successfully",
  invoicingDisabledSuccessfully: "Automatic invoicing disabled successfully",
  errorTogglingInvoicing: "Error toggling automatic invoicing",
  errorFetchingInvoicingStatus: "Error fetching automatic invoicing status",
};

export default adminBackofficeDictEN;
